<template>
  <el-dialog title="批量提交审核" :visible.sync="dialog.visible" width="1100px" append-to-body
    @close="handleClose">
    <el-table ref="table" :data="pagedBodys" v-loading="dialog.loading" row-key="id" highlight-current-row stripe border
      max-height="520px" @selection-change="handleSelectionChange">
      <el-table-column type="selection" reserve-selection width="50" align="center"></el-table-column>
      <el-table-column label="资源位code" prop="code" min-width="140" align="center"></el-table-column>
      <el-table-column label="优先级" prop="pri" width="80" align="center"></el-table-column>
      <el-table-column label="标题" prop="title" min-width="120" align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column label="icon" prop="icon" width="90" align="center">
        <template v-slot="{ row }">
          <el-image v-if="row.icon" :src="row.icon" style="width:60px;height:34px;"
            :preview-src-list="[row.icon]"></el-image>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="图片" prop="image" width="90" align="center">
        <template v-slot="{ row }">
          <el-image v-if="row.image && row.image.trim()" :src="row.image" style="width:60px;height:34px;"
            :preview-src-list="[row.image]"></el-image>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="描述" prop="descInfo" min-width="120" align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column label="渠道配置" prop="appidFilterNames" min-width="120" align="center"
        show-overflow-tooltip>
        <template v-slot="{ row }">
          {{ row.appidFilterNames || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="事件类型" prop="eventType" width="120" align="center">
        <template v-slot="{ row }">
          {{ getEventTypeName(row.eventType) }}
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" width="80" align="center">
        <template v-slot="{ row }">
          <el-tag :type="row.status === 1 ? 'success' : 'info'" size="mini">
            {{ row.status === 1 ? '上架' : '下架' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="审核状态" prop="auditStatus" width="90" align="center">
        <template v-slot="{ row }">
          <el-tag type="warning" size="mini">{{ getAuditStatusName(row.auditStatus) }}</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-wrap">
      <el-pagination background layout="total, prev, pager, next" :total="table.bodys.length"
        :page-size="page.size" :current-page.sync="page.current" @current-change="handlePageChange">
      </el-pagination>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="hide">取 消</el-button>
      <el-button type="primary" :disabled="selection.length === 0" :loading="dialog.submitting"
        @click="handleSubmit">
        提交审核{{ selection.length > 0 ? ` (${selection.length})` : '' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  getResourceChildListLocal,
  appResourceItemBatchReviewSubmit
} from "@/api/desk/notice";
import { getDictionary } from "@/api/system/dictbiz";

// 草稿态审核状态值
const AUDIT_STATUS_DRAFT = 1;
// 单页拉取草稿数据上限（一次性拉取当前资源组下的全部草稿）
const DRAFT_PAGE_SIZE = 1000;
// 弹窗表格前端分页每页条数
const TABLE_PAGE_SIZE = 10;

export default {
  name: "resource-batch-review-dialog",
  data() {
    return {
      dialog: {
        visible: false,
        loading: false,
        submitting: false
      },
      // 当前资源组 id，由父组件在打开弹窗时传入
      groupId: null,
      eventTypeDict: [],
      auditStatusDict: [
        { label: "草稿", value: 1 },
        { label: "审核中", value: 2 },
        { label: "审核通过", value: 3 },
        { label: "审核不通过", value: 4 }
      ],
      table: {
        bodys: []
      },
      page: {
        current: 1,
        size: TABLE_PAGE_SIZE
      },
      selection: []
    };
  },
  computed: {
    // 当前页展示的数据（前端分页切片）
    pagedBodys() {
      const start = (this.page.current - 1) * this.page.size;
      return this.table.bodys.slice(start, start + this.page.size);
    }
  },
  created() {
    this.initEventTypeDict();
  },
  methods: {
    initEventTypeDict() {
      getDictionary({ code: "APP_RESOURCE_CONFIG" }).then(res => {
        this.eventTypeDict = res.data.data || [];
      }).catch(err => {
        console.error(this.$options.name, "事件类型字典获取失败", err);
      });
    },
    show(groupId) {
      this.resetState();
      this.groupId = groupId;
      this.dialog.visible = true;
      this.fetchDraftList();
    },
    hide() {
      this.dialog.visible = false;
    },
    handleClose() {
      this.resetState();
    },
    resetState() {
      this.groupId = null;
      this.table.bodys = [];
      this.selection = [];
      this.page.current = 1;
      this.clearTableSelection();
    },
    clearTableSelection() {
      if (this.$refs.table) {
        this.$refs.table.clearSelection();
      }
    },
    fetchDraftList() {
      this.dialog.loading = true;
      // 只按当前资源组 + 草稿态过滤，避免运营在组内页面看到其他资源组的草稿
      getResourceChildListLocal(1, DRAFT_PAGE_SIZE, this.groupId, {
        auditStatus: AUDIT_STATUS_DRAFT
      }).then(res => {
        this.table.bodys = res.data.data || [];
        this.dialog.loading = false;
      }).catch(err => {
        console.error(this.$options.name, err);
        this.dialog.loading = false;
      });
    },
    handlePageChange(current) {
      this.page.current = current;
    },
    // 依赖 el-table 的 reserve-selection（row-key=id），跨分页累积多选不丢失
    handleSelectionChange(list) {
      this.selection = list;
    },
    handleSubmit() {
      if (this.selection.length === 0) {
        return;
      }
      const ids = this.selection.map(item => item.id);
      this.dialog.submitting = true;
      appResourceItemBatchReviewSubmit(ids).then(() => {
        this.$message.success("提交审核成功");
        this.dialog.submitting = false;
        this.hide();
        this.$emit("success");
      }).catch(err => {
        // 超限等失败由 axios 拦截器统一 toast 后端友好文案，这里仅释放 loading
        console.error(this.$options.name, err);
        this.dialog.submitting = false;
      });
    },
    getEventTypeName(eventType) {
      if (eventType === undefined || eventType === null || eventType === "") {
        return "-";
      }
      const item = this.eventTypeDict.find(dict => dict.dictKey === String(eventType));
      return item ? item.dictValue : eventType;
    },
    getAuditStatusName(auditStatus) {
      const item = this.auditStatusDict.find(dict => dict.value === auditStatus);
      return item ? item.label : "-";
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination-wrap {
  margin-top: 12px;
  text-align: right;
}
</style>
